import { extend } from 'lodash'

import CustomError from '../Utilities/CustomError'

import * as EntityConstants from './EntityConstants'
import Layer from './Layer'

export default class Ellipse {
    constructor(json) {
        this['$type'] = json['$type']
        this.centrePoint = undefined
        this.radiusX = undefined
        this.radiusY = undefined
        this.layer = undefined
        this.isLineTypeSolid = undefined
        this.type = undefined
        this.toSvg = undefined
        this.lineApproximation = []

        const jsonValid =
            json &&
            Object.prototype.hasOwnProperty.call(json, 'layer') &&
            Object.prototype.hasOwnProperty.call(json, 'isLineTypeSolid') &&
            Object.prototype.hasOwnProperty.call(json, 'type') &&
            Object.prototype.hasOwnProperty.call(json, 'centrePoint') &&
            Object.prototype.hasOwnProperty.call(json, 'radiusX') &&
            Object.prototype.hasOwnProperty.call(json, 'radiusY') &&
            Object.prototype.hasOwnProperty.call(json, 'lineApproximation')

        if (jsonValid) {
            extend(this, json)
            this.layer = new Layer(json.layer)
        } else {
            throw new CustomError('Invalid json supplied', 'InvalidJSONError')
        }
    }

    // toSvg() {
    //     return `<ellipse cx="${this.centrePoint.x}" cy="${this.centrePoint.y}" rx="${this.radiusX} ry="${this.radiusY}" />`
    // }
    getSvgPathStr(lastPt) {
        let pathStr = ''
        const lastPtMeetsStartPoint =
            lastPt &&
            Math.abs(lastPt.x - this.lineApproximation[0].startPoint.x) < EntityConstants.POINT_COMPARISON_PRECISION &&
            Math.abs(lastPt.y - this.lineApproximation[0].startPoint.y) < EntityConstants.POINT_COMPARISON_PRECISION

        if (!lastPt || !lastPtMeetsStartPoint) {
            pathStr += !lastPtMeetsStartPoint ? ' ' : ''
            pathStr += 'M' + this.lineApproximation[0].startPoint.x + ' ' + this.lineApproximation[0].startPoint.y
        }

        this.lineApproximation.forEach((line) => {
            pathStr += ' L' + line.endPoint.x + ' ' + line.endPoint.y
        })

        return pathStr
    }
}

Ellipse.ToolpathType = 'DtoEllipse'
